<template>
    <div>
        <a-modal centered v-if="step == 'wrong_password'" :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
            <div class="custom-modal-header">
                <label class="custom-modal-header-title fs-20">
                    {{ $t('ขออภัย') }}
                </label>
            </div>
            <div class="custom-modal-body">
                <label class="custom-modal-body-detail fs-16" style="display: block"> ท่านกรอกข้อมูลไม่ถูกต้อง </label>
                <label class="custom-modal-body-detail fs-16"> กรุณากรอกใหม่อีกครั้ง </label>
            </div>
            <!-- footer -->
            <div class="custom-modal-footer">
                <a-button key="back" class="custom-modal-footer-single-close-btn fs-20" @click="cancel()">
                    {{ $t('ปิดหน้าต่าง') }}
                </a-button>
            </div>
        </a-modal>
        <a-modal centered v-if="step == 'correct_password'" :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
            <div class="custom-modal-body" style="padding-top: 32px; padding-bottom: 32px">
                <img src="../../../public/resources/images/check.png" style="width: 20%; margin: 0 auto; min-width: 25px;" />
                <br />
                <label class="custom-modal-body-detail fs-20 fw-600 mb-0 mt-8">
                    {{ $t('Correct Password') }}
                </label>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { directive as onClickaway } from 'vue-clickaway';
export default {
    props: ['visible', 'step'],
    data() {
        return {};
    },
    methods: {
        cancel() {
            this.$emit('on-cancel');
        },
        create() {
            this.$emit('on-save');
        },
    },
    directives: {
        onClickaway: onClickaway,
    },
};
</script>
<style scoped>
.custom-modal-header {
    background: transparent;
    padding: 16px 10px;
    padding-bottom: 0;
    text-align: center;
}
.custom-modal-header-title {
    color: #141322 !important;
    font-weight: 600;
}
.custom-modal-body {
    background: transparent;
    /* padding: 16px 10px; */
    padding-bottom: 0;
    text-align: center;
}
.custom-modal-body-detail {
    color: #141322 !important;
    font-weight: 300;
}
.custom-modal-footer {
    background: transparent;
    padding: 16px 10px;
}
.custom-modal-footer-single-close-btn {
    background: linear-gradient(0deg, #ff7105, #ff9500 100%) no-repeat;
    color: #fff;
    width: 100%;
}
</style>
